import { Assignment } from "@mui/icons-material";
import Button from "e.sic-platform.webclient/src/components/button/Button";
import useThemeService from "e.sic-platform.webclient/src/services/theme-service/ThemeService";

export default function RunOcrServiceButton(props: {
  onClick: () => void;
  disabled?: boolean;
}) {
  const { themeClass } = useThemeService();

  return (
    <Button
      id="run-ocr-service-sc"
      onClick={props.onClick}
      disabled={props.disabled}
      icon={{
        svg: Assignment,
        textKey: "RunOcrServiceButton.run",
        className: themeClass(["icon-custom"]),
      }}
      className={themeClass(["btn-huge", "run-ai-button"])}
    />
  );
}
